module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGbd8dbbea8a39f3ee1b22f63d8d790cca.bd8dbbea.png";